/**
 * DefinitionService - save definitions to library
 */

import { ApiBaseWeb } from '../ui/services/ApiBaseWeb';
import type { GraphDefinition } from '@/graph/GraphDefinition';

class DefinitionService extends ApiBaseWeb {
  private libraryCache: Record<string, GraphDefinition> | null = null;
  private listeners: Set<() => void> = new Set();

  /**
   * Save a definition to the library
   */
  async save(definition: GraphDefinition): Promise<void> {
    await this.post('library/definition', { definition });
    // Invalidate cache so node menu sees new definition
    this.libraryCache = null;
    this.notifyListeners();
  }

  /**
   * Get all library definitions (cached)
   */
  async getAll(): Promise<Record<string, GraphDefinition>> {
    if (!this.libraryCache) {
      this.libraryCache = await this.get<Record<string, GraphDefinition>>('library/definitions');
    }
    return this.libraryCache;
  }

  /**
   * Invalidate cache and refresh
   */
  async refresh(): Promise<Record<string, GraphDefinition>> {
    this.libraryCache = null;
    return this.getAll();
  }

  /**
   * Subscribe to library changes
   */
  subscribe(listener: () => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  private notifyListeners(): void {
    for (const listener of this.listeners) {
      listener();
    }
  }
}

export const definitionService = new DefinitionService();
